module.exports = __webpack_public_path__ + "img/5.b815eda9.jpg";